module.exports = __webpack_public_path__ + "static/flags/LR-78b42bbdcff27626a5e4d48de5d8a003.gif";